import {
    request as getRelatedContingencyRequest,
    error as getRelatedContingencyError,
    finish as getRelatedContingencyFinish,
} from './reducers/get-related-contingency';

import {
    request as createRelatedContingencyRequest,
    error as createRelatedContingencyError,
    finish as createRelatedContingencyFinish,
} from './reducers/create-related-contingency';

import {
    request as updateRelatedContingencyRequest,
    error as updateRelatedContingencyError,
    finish as updateRelatedContingencyFinish,
} from './reducers/update-related-contingency';

import {
    request as addMarketsToTagRequest,
    error as addMarketsToTagError,
    finish as addMarketsToTagFinish,
} from './reducers/add-markets';

import {
    request as getMarketsForTagRequest,
    error as getMarketsForTagError,
    finish as getMarketsForTagFinish,
} from './reducers/get-markets-for-rc-tag';

import {
    request as removeMarketsFromTagRequest,
    error as removeMarketsFromTagError,
    finish as removeMarketsFromTagFinish,
} from './reducers/remove-market-from-tag';

import {
    request as getEventInfoByTagIdRequest,
    error as getEventInfoByTagIdError,
    finish as getEventInfoByTagIdFinish,
} from './reducers/get-event-info';

import { simple } from 'src/utils/reducers';

// eslint-disable-next-line import/no-default-export
export default simple({
    //get all
    GET_RELATED_CONTINGENCY_REQUEST: getRelatedContingencyRequest,
    GET_RELATED_CONTINGENCY_ERROR: getRelatedContingencyError,
    GET_RELATED_CONTINGENCY_FINISH: getRelatedContingencyFinish,

    //create
    CREATE_RELATED_CONTINGENCY_REQUEST: createRelatedContingencyRequest,
    CREATE_RELATED_CONTINGENCY_ERROR: createRelatedContingencyError,
    CREATE_RELATED_CONTINGENCY_FINISH: createRelatedContingencyFinish,

    //update
    UPDATE_RELATED_CONTINGENCY_REQUEST: updateRelatedContingencyRequest,
    UPDATE_RELATED_CONTINGENCY_ERROR: updateRelatedContingencyError,
    UPDATE_RELATED_CONTINGENCY_FINISH: updateRelatedContingencyFinish,

    //add markets to tag
    ADD_MARKETS_TO_TAG_REQUEST: addMarketsToTagRequest,
    ADD_MARKETS_TO_TAG_REQUEST_ERROR: addMarketsToTagError,
    ADD_MARKETS_TO_TAG_REQUEST_FINISH: addMarketsToTagFinish,

    //get markets for tag
    GET_MARKETS_FOR_TAG_REQUEST: getMarketsForTagRequest,
    GET_MARKETS_FOR_TAG_ERROR: getMarketsForTagError,
    GET_MARKETS_FOR_TAG_FINISH: getMarketsForTagFinish,

    //remove market form tag
    DELETE_MARKET_FROM_TAG_REQUEST: removeMarketsFromTagRequest,
    DELETE_MARKET_FROM_TAG_REQUEST_ERROR: removeMarketsFromTagError,
    DELETE_MARKET_FROM_TAG_REQUEST_FINISH: removeMarketsFromTagFinish,

    //event info by tag id
    GET_EVENT_INFO_BY_CONTINGENCY_ID_REQUEST: getEventInfoByTagIdRequest,
    GET_EVENT_INFO_BY_CONTINGENCY_ID_ERROR: getEventInfoByTagIdError,
    GET_EVENT_INFO_BY_CONTINGENCY_ID_FINISH: getEventInfoByTagIdFinish,
});
